/**
 * Import modules
 */
import api from '../../api';
import * as _ from 'lodash';


/**
 * Get slider item
 * @param slidersList
 * @param configurationsList
 * @param sliderConfigId
 */
function getSliderItem(slidersList, configurationsList, sliderConfigId) {
    // get slider config item
    let sliderConfigItem = _.find(configurationsList, function(configItem) {
        return configItem.configId === sliderConfigId;
    });
    // get slider id
    let sliderConfigValue = sliderConfigItem.configValue;
    // get top-banner
    return _.find(slidersList, function(sliderItem) {
        return sliderItem.sliderId === sliderConfigValue;
    });
}

/**
 * Define state
 * @type {{currentUserInfo: null, isAuthenticated: boolean}}
 */
const state = {
    topSlider: {},
    aboutUsSlider: {},
    productsSlider: {},
    partnersSlider: {}
};

/**
 * Define getters
 * @type {{}}
 */
const getters = {

};

/**
 * Define actions
 * @type {{}}
 */
const actions = {
    /**
     * Get all sliders list
     * @param commit
     * @param rootState
     * @returns {Promise<void>}
     */
    async getAllSlidersList({commit, rootState}) {
        await api.getAllSlidersList()
            .then((response) => {
                // get sliders list
                let allSlidersList = response.data.data;

                // get slider
                let topSlider = getSliderItem(allSlidersList, rootState.configurations.configurationsList, process.env.VUE_APP_TOP_SLIDER_CONFIG_ID);
                let aboutUsSlider = getSliderItem(allSlidersList, rootState.configurations.configurationsList, process.env.VUE_APP_ABOUT_US_CONFIG_ID);
                let productsSlider = getSliderItem(allSlidersList, rootState.configurations.configurationsList, process.env.VUE_APP_PRODUCTS_CONFIG_ID);
                let partnersSlider = getSliderItem(allSlidersList, rootState.configurations.configurationsList, process.env.VUE_APP_PARTNERS_CONFIG_ID);

                // commit
                commit('GET_ALL_SLIDERS_LIST_SUCCESSFULLY', {
                    topSlider, aboutUsSlider, productsSlider, partnersSlider
                });
            })
    },


};

/**
 * Define mutations
 * @type {{}}
 */
const mutations = {
    /**
     * Get all sliders list successfully
     * @param state
     * @param slidersList
     * @constructor
     */
    GET_ALL_SLIDERS_LIST_SUCCESSFULLY(state, slidersList) {
        state.topSlider = slidersList.topSlider;
        state.aboutUsSlider = slidersList.aboutUsSlider;
        state.productsSlider = slidersList.productsSlider;
        state.partnersSlider = slidersList.partnersSlider;
    }
};

/**
 * Export module
 */
export default {
    state,
    getters,
    actions,
    mutations
}
